import { STYLE_UNITS } from '@/styles'

export const popperDimensions = {
  padding: 1.5,
  paddingInPx: 1.5 * STYLE_UNITS.SPACING_MULTIPLIER,
}
